export default (state, action) => {
  const { payload } = action;
  const allProductsEligible = payload.productList.reduce((acc, item) => acc && item.eligible, true);
  return {
    ...state,
    eligibilityList: payload.productList,
    allProductsEligible,
  };
};
